<template>
  <div class="patrol-plan-main">
    <!--巡更计划列表-->
    <div class="plan-list-panel">
      <div class="plan-list" :class="{ 'plan-list-show': showLeftPanel }">
        <div class="planSearch">
          <el-input
            style="width: 75%"
            v-model="searchPlanName"
            @keyup.enter.native="queryListData"
            clearable
            @clear="queryListData"
            placeholder="请输入计划名称"
          >
          </el-input>
          <span> | </span>
          <img @click="queryListData" src="@src/common/assets/images/search.png" alt="" />
        </div>
        <div
          class="box-card"
          v-loading="listLoading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-scrollbar class="scroll-content" ref="refScrollbar" style="height: 100%">
            <div
              v-for="item in planList"
              :key="item.id"
              :class="
                activePlanInfo && item.patrolPlanCode == activePlanInfo.patrolPlanCode
                  ? 'active'
                  : ''
              "
              class="text item map-blur-panel__list-item"
              @click.prevent="handleOpenDetail(item)"
            >
              <span class="flex-p4">
                <el-tooltip placement="top-start" :content="item.planName">
                  <div class="plan-list-tab">
                    <span slot="content">{{ item.planName }}</span>
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-if="item.planStatus == 2"
                  effect="dark"
                  content="启动"
                  placement="top-start"
                  :visible-arrow="false"
                >
                  <span
                    class="icon iconfont icon-qiyong"
                    @click.stop="updateStatus('1', item)"
                  ></span>
                </el-tooltip>
                <el-tooltip
                  v-if="item.planStatus == 1"
                  effect="dark"
                  :content="$t('videoPatrol.button.stop')"
                  placement="top-start"
                  :visible-arrow="false"
                >
                  <span
                    class="icon iconfont icon-jinyong1"
                    v-auth="'/videoPatrol/plan:update'"
                    @click.stop="updateStatus('2', item)"
                  ></span>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="编辑"
                  placement="top-start"
                  :visible-arrow="false"
                >
                  <span
                    style="margin: 0 16px"
                    class="icon iconfont icon-xiugai"
                    v-auth="'/elePatrol-patrolplan:update'"
                    @click.stop="showEditPanel(item)"
                  ></span>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="删除"
                  placement="top-start"
                  :visible-arrow="false"
                >
                  <span
                    class="icon iconfont icon-shanchu"
                    v-auth="'/elePatrol-patrolplan:delete'"
                    @click.stop="deleteOne(item)"
                  ></span>
                </el-tooltip>
              </span>
              <div class="list-operator">
                <div class="list-item">
                  <span class="list-label"
                    >巡更点: {{ item.patrolPlanPointList.length }} 个</span
                  >
                  <span> 状态：{{ item.planStatus == 1 ? "启用" : "停用" }} </span>
                </div>
              </div>
              <div class="list-operator">
                <div class="list-item">
                  <span class="list-label">创建人: {{ item.creator }}</span>
                  <span>创建日期：{{ item.createTime }} </span>
                </div>
              </div>
            </div>
            <div class="no-data-text" v-if="planList.length == 0">
              <div>
                <img src="@/common/assets/images/empty.svg" class="no-data_img" />
              </div>
              <div>暂无数据</div>
            </div>
          </el-scrollbar>
        </div>
        <div class="plan-list-toolbar">
          <div class="addbtn">
            <el-button
              type="primary"
              v-auth="'/elePatrol-patrolplan:add'"
              @click="handleAddBtn"
            >
              创建巡更计划
            </el-button>
          </div>
          <!-- 摄像机 -->
          <div class="tool-camera">
            <el-button type="primary" @click="handleShowCamera">
              {{ showCamera ? "隐藏摄像机" : "显示摄像机" }}
            </el-button>
          </div>
          <div
            class="map-blur-panel__expand-button left iconfont-lunan"
            :class="
              showLeftPanel ? 'icon-lunan-shousuocaidan' : 'icon-lunan-shousuocaidan-copy'
            "
            @click="showPlanListPanel"
          ></div>
        </div>
      </div>
    </div>
    <patrol-panel
      ref="planInfoPanel"
      :panelType="panelType"
      :showPanel="showRightPanel"
      @handleSaveEmit="handleSaveEmit"
      @handleCancelPanel="handleCancelPanel"
      @handleFloorCenter="handleFloorCenter"
    ></patrol-panel>
    <floorDraw
      ref="floorDraw"
      :panelType="panelType"
      @handleAddPoint="handleAddPoint"
      @handleClosePoint="handleClosePoint"
    >
    </floorDraw>
  </div>
</template>
<script>
import PatrolPanel from "../components/patrolPanel";
import floorDraw from "../components/floorDraw";
import pointDetails from "../components/pointDetails.vue";
import floorDetails from "../components/floorDetails.vue";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dates } from "$utils";
import Vue from "vue";
export default {
  name: "patrol-plan",
  components: {
    PatrolPanel,
    floorDraw,
  },
  data() {
    return {
      showCamera: false,
      // 地图打点图标图层对象
      isIndoor: false, //室内市外
      drawPoint: [],
      longitude: undefined,
      latitude: undefined,
      total: 0,
      pageSize: 30,
      currentPage: 1,
      planList: [],
      showLeftPanel: false,
      showRightPanel: false,
      searchPlanName: "",
      searchParams: "",
      panelType: 2,
      // 巡更点位信息
      addMarketPoint: [],
      // 楼栋信息
      addMarketFloor: [],
      floorInfo: [], //楼层信息
      propMarkerVue: null,
      allPoint: "allPoint", //所有点位图层-gps
      allPointQr: "allPointQr", //所有点位图层-二维码
      detailFloorId: "allFloorId", //楼栋图层
      detailPointCirclesId: "detailPointCirclesId", //选中列详情所展示的序号图层
      activePlanInfo: null, //当前点击的计划详情
      boxScrollContainer: "",
      listLoading: false,
    };
  },
  beforeDestroy() {
    this.$map.MapInstance2D.clearOverlays();
    this.$map.hideMap2D();
  },
  created() {},
  mounted() {
    this.scrollbar();
    this.showLeftPanel = true;
    this.$map.showMap2D(() => {
      this.$map.MapInstance2D.setMapCenter();
      this.$map.MapInstance2D.setMapZoom(16);
      this.$map.MapInstance2D.initPage(false);
    });
    // 初始化查询巡更计划列表
    this.getPatrolPlanList({ planName: this.searchPlanName });
    // 获取所有楼栋数据
    this.getFloorList();
    // 获取所有公共点位
    this.getAllPoint();
  },
  methods: {
    handleShowCamera() {
      this.showCamera = !this.showCamera;
      this.$map.MapInstance2D.setLayerVisibleById("CAMERA", this.showCamera);
    },
    scrollbar() {
      let list = this.$refs.refScrollbar;
      this.boxScrollContainer = list.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.listLoading &&
          this.planList.length % 30 === 0 &&
          this.planList.length !== 0
        ) {
          this.pageNum += 1;
          this.pageChange();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    // 查询所有点位
    getAllPoint() {
      this.$fetch(api.patrolplan.queryAllPoint).then((res) => {
        if (res.success) {
          this.addMarketPoint = res.returnObj;
          this.addAllPoint();
        } else {
          this.$message.error(res.msgContent || "查询点位数据出错");
        }
      });
    },
    handleClosePoint() {
      this.showLeftPanel = true;
    },
    handleAddPoint(data) {
      // console.log(data);
      let point = this.$refs.planInfoPanel.patrolPointTable.filter((item) => {
        return item.area == "室外";
      });
      console.log(point);
      data.forEach((item) => {
        // 添加新的图纸点位
        // if (!item.pointCode) {
        point.push({
          ...item,
          area: "室内",
          coord: [item.x, item.y],
        });
        // }
      });
      this.$refs.planInfoPanel.patrolPointTable = [...point];
      console.log(this.$refs.planInfoPanel.patrolPointTable);
      // }
    },
    handleFloorCenter(info) {
      this.addMarketFloor.forEach((item) => {
        if (item.buildingCode == info.buildingId) {
          this.$map.MapInstance2D.setMapCenter([+item.lng, +item.lat]);
        }
      });
    },
    getFloorInfo(e) {
      let params = {
        pageFlag: false,
        buildingCode: e.marker.attr.buildingCode,
        buildingType: 2, //1楼栋2楼层
      };
      this.$fetch(api.queryBuildingList, params).then((res) => {
        if (res.success) {
          e.marker.attr.floorInfo = res.returnObj;
          this.handleShowPopup(floorDetails, e);
        } else {
          this.$message.error(res.msgContent || "查询楼层数据出错");
        }
      });
    },
    getFloorList() {
      let params = {
        pageFlag: false,
        buildingType: 1, //1楼栋2楼层
      };
      this.addMarketFloor = [];
      this.$fetch(api.queryBuildingList, params).then((res) => {
        if (res.success) {
          this.addMarketFloor = res.returnObj;
          this.addMarkFloor();
        } else {
          this.$message.error(res.msgContent || "查询楼栋数据出错");
        }
      });
    },

    addMarkFloor() {
      let addMarkInfo = [];
      this.addMarketFloor.forEach((item, index) => {
        if (!item.lng || !item.lng) return;
        addMarkInfo.push({
          id: item.buildingCode,
          longitude: Number(item.lng),
          latitude: Number(item.lat),
          coord: [Number(item.lng), Number(item.lat)],
          anchor: [20, 20],
          scale: 1,
          isHover: true,
          src: "/images/theme/newDark/map/floor-InActive.png",
          sleSrc: "/images/theme/newDark/map/floor-Active.png",
          attr: {
            ...item,
          },
        });
      });
      if (!this.$map.MapInstance2D) {
        setTimeout(() => {
          this.$map.MapInstance2D.addMarket(
            addMarkInfo,
            this.detailFloorId,
            this.handleFloorClick
          );
        }, 100);
      } else {
        this.$map.MapInstance2D.addMarket(
          addMarkInfo,
          this.detailFloorId,
          this.handleFloorClick
        );
      }
    },
    handleFloorClick(e) {
      // console.log(e);
      // this.$nextTick(() => {
      //   this.$map.MapInstance2D.setFeaHighlightById(this.detailFloorId, [
      //     this.detailFloorId + "-" + e.marker.attr.buildingCode,
      //   ]);
      // });

      this.getFloorInfo(e);
    },
    addAllPoint() {
      let addMarkInfo = [];
      let addMarkInfoQr = [];
      this.addMarketPoint.forEach((item, index) => {
        if (item.location == "室外") {
          let longitude = Number(item.longitude);
          let latitude = Number(item.latitude);
          if (item.punchType == 0) {
            addMarkInfo.push({
              longitude: longitude,
              latitude: latitude,
              coord: [longitude, latitude],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/map/point-InActive.png",
              // punchType：0 GPS,1 二维码
              sleSrc: "/images/theme/newDark/map/point-Active.png",
              attr: {
                ...item,
              },
            });
          } else {
            addMarkInfoQr.push({
              longitude: longitude,
              latitude: latitude,
              coord: [longitude, latitude],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/map/pointQr-InActive.png",
              // punchType：0 GPS,1 二维码
              sleSrc: "/images/theme/newDark/map/pointQr-Active.png",
              attr: {
                ...item,
              },
            });
          }
        }
      });
      this.$nextTick(() => {
        this.$map.MapInstance2D.addMarket(
          addMarkInfo,
          this.allPoint,
          this.handlePointClick
        );
        this.$map.MapInstance2D.addMarket(
          addMarkInfoQr,
          this.allPointQr,
          this.handlePointClick
        );
      });
    },
    // 点位图标点击回调事件
    handlePointClick(e) {
      console.log(e);
      // 0 新增，1编辑 2 详情,
      if (this.panelType == 0 || this.panelType == 1) {
        // 编辑状态下直接选中作为新建巡更点
        let checkPoint = this.$refs["planInfoPanel"].patrolPointTable;
        if (
          checkPoint.some((item) => {
            return item.pointCode == e.marker.attr.pointCode;
          })
        ) {
          this.$message.warning("该点位已在本次计划内，请勿重复选择");
          return;
        }
        this.$refs["planInfoPanel"].patrolPointTable.push({
          name: e.marker.attr.pointName,
          area: e.marker.attr.location,
          type: e.marker.attr.punchType,
          pointCode: e.marker.attr.pointCode,
          coord: [e.marker.longitude, e.marker.latitude],
          // coord: e.marker.coord,
        });
        this.$refs["planInfoPanel"].handleChangePoint();

        return;
      }
      this.handleShowPopup(pointDetails, e);
    },
    handleShowPopup(ele, e) {
      // console.log(e);
      this.$map.MapInstance2D.addPopupMap({
        offset: [0, 0],
        position: e.marker.coord, // 经纬度
        // content: '<div id="gis_popup"></div>',//弹窗父组件默认gis_popup
        // layerId: "tip" + e.marker.attr.buildingCode,//弹窗标识
        // isSingle: true//是否单个显示
      });
      let propMarkerVue = null;
      propMarkerVue = new Vue(ele).$mount("#gis_popup");
      propMarkerVue.options = e.marker.attr;
      propMarkerVue.pointCode = e.marker.attr.pointCode;
      propMarkerVue.$on("handleDel", () => {
        this.$map.MapInstance2D.removePopup();
        propMarkerVue.$off();
        propMarkerVue.$destroy();
        propMarkerVue = null;
        this.getAllPoint();
      });
      propMarkerVue.$on("closeTip", (e) => {
        // console.log(e);
        this.$map.MapInstance2D.removePopup();
        propMarkerVue.$off();
        propMarkerVue.$destroy();
        propMarkerVue = null;
        if (this.$refs.floorDraw.showDrawPanel) {
          this.$refs.floorDraw.handleClosePanel();
        }
      });
      propMarkerVue.$on("handleOpenDraw", (info) => {
        // this.$map.MapInstance2D.setMapCenter([
        //   e.marker.coord[0] + 0.0053,
        //   e.marker.coord[1] - 0.0005,
        // ]);
        this.$map.MapInstance2D.setMapZoom(17);
        this.showLeftPanel = false;
        // console.log(this.panelType);
        if (this.panelType == 0 || this.panelType == 1) {
          // 编辑状态
          this.$refs.floorDraw.handleOpenPanel(
            info,
            {
              patrolPlanPointList: this.$refs.planInfoPanel.patrolPointTable,
            },
            e.marker.attr
          );
        } else {
          // 查看状态
          this.$refs.floorDraw.handleOpenPanel(info, this.activePlanInfo, e.marker.attr);
        }
      });
    },
    //新建/编辑计划点击取消按钮
    handleCancelPanel() {
      this.$map.MapInstance2D.clearLayer(this.detailPointCirclesId);
      this.panelType = 2;
      this.showRightPanel = false;
      this.activePlanInfo = null;
    },
    //启停计划
    updateStatus(code, data) {
      this.$fetch(api.patrolplan.updatePlanStatus, {
        patrolPlanCode: data.patrolPlanCode,
        planStatus: code,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        code == 1 ? this.$message.success("启动成功") : this.$message.success("停用成功");
        this.getPatrolPlanList({ planName: this.searchPlanName });
      });
    },
    //新增成功刷新计划列表
    handleSaveEmit() {
      this.panelType = 2;
      this.$nextTick(() => {
        this.activePlanInfo = null;
        this.showRightPanel = false;
        this.getAllPoint();
        this.getPatrolPlanList({ planName: this.searchPlanName });
      });
    },

    //修改巡更计划
    showEditPanel(row) {
      console.log(row);
      if (this.showRightPanel) {
        this.$refs.planInfoPanel.handleClosePanel();
        setTimeout(() => {
          this.showEditPanel(row);
        }, 300);
        return;
      }

      this.$fetch(api.patrolplan.queryPatrolPlan, {
        patrolPlanCode: row.patrolPlanCode,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.activePlanInfo = {
          ...row,
          patrolPlanCycleList: res.returnObj.patrolPlanCycleList,
          accountNumberDetail: res.returnObj.accountNumberDetail,
        };
        this.panelType = 1;
        this.showRightPanel = true;
        this.$map.MapInstance2D.clearLayer(this.detailPointCirclesId);
        let pointList = [];
        row.patrolPlanPointList.forEach((item) => {
          if (item.location == "室外") {
            pointList.push(item);
          }
        });
        pointList.length &&
          this.$map.MapInstance2D.setMapCenter([
            +pointList[0].longitude,
            +pointList[0].latitude,
          ]);
        this.$nextTick(() => {
          this.$refs.planInfoPanel.open(this.activePlanInfo);
        });
      });
    },

    //删除巡更计划
    deleteOne(row) {
      this.$confirm("此操作将永久删除该计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            patrolPlanCode: row.patrolPlanCode,
          };
          this.$fetch(api.patrolplan.deletePatrolPlan, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.$map.MapInstance2D.clearLayer(this.detailPointCirclesId);
              this.getPatrolPlanList({ planName: this.searchPlanName });
            } else {
              this.$message({
                type: "error",
                message: res.msgContent,
              });
            }
          });
        })
        .catch();
    },
    addPointCircles(data) {
      let circleInfo = [];
      data.forEach((item) => {
        circleInfo.push({
          longitude: item.longitude,
          latitude: item.latitude,
          radius: 9, //半径
          label: String(item.index),
          outline: false, //是否显示轮廓线
          outlineWidth: 1,
          height: 10, //高度
          outlineColor: "#3E76E6", //轮廓线颜色
          fill: true, //是否填充颜色
          fillColor: "#3E76E6", //颜色
          attr: {
            ...item,
          },
        });
      });
      this.$nextTick(() => {
        this.$map.MapInstance2D.addCircles(
          circleInfo,
          this.detailPointCirclesId,
          this.handlePointClick
        );
      });
    },
    // 查看巡更详情,绘制巡更点位效果图
    handleOpenDetail(row) {
      if (this.showRightPanel) {
        this.$refs.planInfoPanel.handleClosePanel();
        setTimeout(() => {
          this.handleOpenDetail(row);
        }, 300);
        return;
      }
      this.$map.MapInstance2D.clearLayer("temporaryPointNum");
      this.$fetch(api.patrolplan.queryPatrolPlan, {
        patrolPlanCode: row.patrolPlanCode,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.activePlanInfo = {
          ...row,
          patrolPlanCycleList: res.returnObj.patrolPlanCycleList,
          accountNumberDetail: res.returnObj.accountNumberDetail,
        };
        this.panelType = 2;
        this.showRightPanel = true;
        let pointList = [];
        row.patrolPlanPointList.forEach((item, index) => {
          if (item.location == "室外") {
            pointList.push({
              ...item,
              index: index + 1,
            });
          }
        });

        pointList.length &&
          this.$map.MapInstance2D.setMapCenter([
            +pointList[0].longitude,
            +pointList[0].latitude,
          ]);
        // 显示当前巡更点位信息
        this.$nextTick(() => {
          this.addPointCircles(pointList);
          this.$refs.planInfoPanel.open(this.activePlanInfo);
        });
      });
    },
    // 收起左侧面板
    showPlanListPanel() {
      this.showLeftPanel = !this.showLeftPanel;
    },
    // 创建计划
    handleAddBtn() {
      if (this.showRightPanel) {
        this.$refs.planInfoPanel.handleClosePanel();
        setTimeout(() => {
          this.handleAddBtn();
        }, 300);
        return;
      }
      if (this.$refs.floorDraw.showDrawPanel) {
        this.$refs.floorDraw.handleClosePanel();
        setTimeout(() => {
          this.handleAddBtn();
        }, 300);
      }
      this.panelType = 0;
      this.showRightPanel = true;
      // 清空已有的序号
      this.$map.MapInstance2D.clearLayer(this.detailPointCirclesId);
    },
    //查询巡更计划列表
    getPatrolPlanList({ planName = "", pageNum = 1, pageSize = 10 }) {
      const self = this;
      const params = {
        planName: planName,
        pageNum: pageNum,
        pageSize: pageSize,
      };
      self.currentPage = pageNum;
      this.listLoading = true;
      this.$fetch(api.patrolplan.queryPatrolPlanList, params).then((response) => {
        this.listLoading = false;
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        if (response.returnObj && response.returnObj.list) {
          if (pageNum == 1) {
            self.planList = [];
          }
          let queryPatrolPlanList = Object.freeze(response.returnObj).list;
          let planList = queryPatrolPlanList.map((item) => {
            return {
              planName: item.planName,
              patrolPlanCode: item.patrolPlanCode,
              planStartTime: Dates.format(item.planStartTime, "yyyy-MM-dd"),
              planEndTime: Dates.format(item.planEndTime, "yyyy-MM-dd"),
              patrolStartTime: Dates.format(item.patrolStartTime, "HH:mm"),
              patrolEndTime: Dates.format(item.patrolEndTime, "HH:mm"),
              planStatus: item.planStatus,
              patrolPlanPointList: item.patrolPlanPointList,
              deviation: item.deviation,
              dateType: item.dateType,
              creator: item.creator,
              createTime: Dates.format(item.createTime, "yyyy-MM-dd"),
            };
          });
          this.planList = this.planList.concat(...planList);
          // self.total = response.returnObj.total;
        } else {
          self.planList = [];
          self.total = 0;
        }
      });
    },
    pageChange(pageNo) {
      this.getPatrolPlanList({ planName: this.searchParams, pageNum: pageNo });
    },
    queryListData() {
      this.searchParams = this.searchPlanName;
      this.getPatrolPlanList({ planName: this.searchParams });
    },
  },
};
</script>
<style lang="scss" scoped>
.tool-camera {
  position: absolute;
  right: -220px;
  top: 5px;
  transition: all 500ms linear;
}
.planSearch {
  background: #fff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 4px 0;
  :deep .el-input__inner {
    // background: #262b37;
    // border: none !important;
    // height: 40px;
  }
  span {
    height: 20px;
  }
  img {
    // width: 16px;
    // height: 16px;
    cursor: pointer;
  }
}
:deep .el-scrollbar__wrap {
  height: 101%;
}
.data-pagination {
  backdrop-filter: blur(6px);
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.flex-p4 {
  display: flex;
  justify-content: space-between;
  height: 24px;
  font-size: 16px;
  border-bottom: 1px solid #353e59;
  .plan-list-tab {
    span {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 200px;
      white-space: nowrap;
      font-size: 15px;
      padding: 0px;
    }
  }
}
.no-data-text {
  margin-top: 20%;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // @include set_theme_color(color, font-disabled-color);
  .no-data_img {
    margin-bottom: 10px;
  }
}
.iclass {
  color: #fff;
  cursor: pointer;
  @include set_theme_color(background-color, main-theme-color);
  padding: 8px 10px 7px;
}
@import "../style/plan.scss";
</style>
<style>
.patrol-plan-main .el-form-item__error {
  width: 100%;
}
.language_en_US .patrol-plan-main .plan-patrol {
  margin-bottom: 20px;
}
.patrol-plan-main .el-pagination .btn-prev {
  background-color: initial;
}
.patrol-plan-main .el-pagination .btn-next {
  background-color: initial;
}
.patrol-plan-main .el-pager li {
  background-color: initial;
}
.patrol-plan-main .el-transfer-panel__list {
  height: 120px;
}
.patrol-plan-main .el-card {
  background-color: rgba(0, 0, 0, 0.01);
}
.patrol-plan-main .el-card__header {
  border-bottom: none;
}
.patrol-plan-main .plan-patrol {
  margin-bottom: 20px;
}
.patrol-plan-main img {
  border: none;
  vertical-align: middle;
}
.patrol-plan-main .errmsg {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
.patrol-plan-main .errmsg {
  animation: fadeout 0.2s;
}
@keyframes fadeout {
  0% {
    opacity: 0;
    padding-top: 0;
  }
  50% {
    opacity: 0.5;
    padding-top: 2px;
  }
  100% {
    opacity: 1;
    padding-top: 4px;
  }
}
</style>
